module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('categoria-indicadores', {
    attrs: {
      "titulo": "Indicadores gerais dos reatores",
      "ids": _vm.categorias.indicadoresGerais,
      "registros": _vm.registros,
      "idioma": _vm.idioma
    }
  }), _vm._v(" "), _c('categoria-indicadores', {
    attrs: {
      "titulo": "Indicadores biológicos",
      "ids": _vm.categorias.indicadoresBiologicos,
      "registros": _vm.registros,
      "idioma": _vm.idioma
    }
  }), _vm._v(" "), _c('categoria-indicadores', {
    attrs: {
      "titulo": "Indicadores Awite",
      "ids": _vm.categorias.indicadoresAwite,
      "registros": _vm.registros,
      "idioma": _vm.idioma
    }
  }), _vm._v(" "), _c('categoria-indicadores', {
    attrs: {
      "titulo": "Indicadores do biogás no Biodigestor (Sistema Awite)",
      "ids": _vm.categorias.indicadoresBiogasAwiteBiodigestor,
      "registros": _vm.registros,
      "idioma": _vm.idioma
    }
  }), _vm._v(" "), _c('categoria-indicadores', {
    attrs: {
      "titulo": "Indicadores do biogás na Lagoa (Sistema Awite)",
      "ids": _vm.categorias.indicadoresBiogasAwiteLagoa,
      "registros": _vm.registros,
      "idioma": _vm.idioma
    }
  }), _vm._v(" "), _c('categoria-indicadores', {
    attrs: {
      "titulo": "Indicadores do biogás no Ponto de Consumo (Sistema Awite)",
      "ids": _vm.categorias.indicadoresBiogasAwitePontoConsumo,
      "registros": _vm.registros,
      "idioma": _vm.idioma
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21d16616"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Dashboard.vue
// module id = 669
// module chunks = 1